import type { FunctionComponent } from 'react';

import type { InsightCategoryT } from 'utils';

import S from './style.scss';

type PropsT = {
  category: InsightCategoryT;
  children: string;
};

export const Insight: FunctionComponent<PropsT> = ({
  category,
  children,
}) => {
  let className = S.container;

  switch (category) {
    case 'Context':
      className += ` ${S.context}`;
      break;
    case 'Emotional':
      className += ` ${S.emotion}`;
      break;
    case 'Intention':
      className += ` ${S.intention}`;
      break;
    case 'Mental':
      className += ` ${S.mental}`;
      break;
    case 'Physical':
      className += ` ${S.physical}`;
      break;
    default:
  }

  return <div className={className}>{children}</div>;
};
